import React, { useRef } from 'react';
import { useSlateStatic } from 'slate-react';

import * as serializer from 'basic-editor-value-serializer';

import nodeControls from '../../node-menu/control-types';

import BaseElement from '../base';
import { determineBaseProperties } from '../utilities';

import { placeCaretInItem } from './cell-click';
import { useGapFocus } from './gap-focus';
import GapResizer from './gap-resizer';

import './index.scss';

const layoutUtilities = serializer.utilities.node.layout;

function Layout(props) {

  const editor = useSlateStatic();
  const element = props.element;
  const resolvedSettings = layoutUtilities.resolveSettings(element);
  const containerReference = useRef(null);

  useGapFocus(containerReference);

  function renderCells() {

    const renderedChildren = React.Children.toArray(props.children);
    const cells = [];

    for (let index = 0; index < renderedChildren.length; index++) {

      const cellAttributes = {
        className: 'layout-cell',
        style: layoutUtilities.getCellStyleObject(resolvedSettings, element.children[index]),
        onMouseDown: placeCaretInItem.bind(null, editor, element, index)
      };

      cells.push(<div key={renderedChildren[index].key} {...cellAttributes}>{renderedChildren[index]}</div>);

    }

    return cells;

  }

  function renderLayout() {

    const wrapperAttributes = {
      ...props.attributes,
      className: 'layout-wrapper'
    };
    const containerAttributes = {
      className: 'layout-container',
      ref: containerReference,
      style: layoutUtilities.getContainerStyleObject(resolvedSettings)
    };

    return <div {...wrapperAttributes}>
      <div {...containerAttributes}>
        {renderCells()}
      </div>
      <GapResizer element={element} containerReference={containerReference} />
    </div>;

  }

  const baseElementProperties = determineBaseProperties({
    ...props,
    className: 'layout-node',
    customNodeControls: [nodeControls.LAYOUT_SETTINGS]
  });

  return <BaseElement {...baseElementProperties}>
    {renderLayout()}
  </BaseElement>;

}

export default Layout;
